<template>
  <div class="tw-flex tw-flex-wrap tw-items-center tw-text-center tw-mt-5" v-if="meta">
    <div :class="[ border ? 'tw-w-full md:tw-w-2/2 lg:tw-w-6/6 tw-py-3' : 'tw-hidden' ]">
      <hr class="fading" />
    </div>

   <div  :class="[ showInfo ? 'tw-w-full md:tw-w-1/2 lg:tw-w-1/6' : 'tw-hidden' ]">
      <span   >Toplam {{ meta.total }} kayıt</span><br><br>
   
      <br>
          </div>
    <div :class="[ showInfo ? 'tw-w-full md:tw-w-1/2 lg:tw-w-5/6' : 'tw-w-full' ]">
<!--      :total-visible="totalVisible"-->
      <vs-pagination
     
          :total="meta.last_page"
          v-model="page"
          :max="6"
          icon-pack="mdi"
          prev-icon="mdi-chevron-left"
          next-icon="mdi-chevron-right"
          @change="input"
      ></vs-pagination>

    </div>
  </div>
</template>

<script>
  import { scrollToTop } from '@/utils/Util'

  export default {
    name: "Paginator",
    props: {
      meta: {
        required: true,
      },

      totalVisible: {
        type: Number,
        default: 7,
      },

      border: {
        default: false,
        type: Boolean,
      },

      showInfo: {
        default: true,
        type: Boolean,
      },

      color: {
        type: String,
        default: 'primary'
      }
    },

    data() {
      return {
        page: this.meta.current_page,
      }
    },

    computed: {
      //
    },

    watch: {
      // page(val) {
      //     this.$emit('change', val)
      // },

      meta(val) {
        this.page = val.current_page
      },
    },

    methods: {
      input(page) {
        
        this.$emit('change', page)
      },
    },

    mounted() {

    }
  }
</script>

<style scoped>
.mar-lef{
  margin-right:10%;
}
</style>